import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { AppLang } from "@/locale/appLang";
import { LANG_STORAGE_KEY } from "@/locale/appLang";
import { localizedPath, parseLocalePath } from "@/locale/routes";
import { useLocale } from "@/locale/LocaleProvider";

/** Синхронизирует язык UI с URL (`/` → ru, `/uk|/kk|/uz|/ky/*` → локаль). */
export function LocaleUrlSync() {
  const { pathname } = useLocation();
  const { lang, setLang } = useLocale();

  useEffect(() => {
    const { lang: urlLang } = parseLocalePath(pathname);
    if (urlLang !== lang) {
      setLang(urlLang);
    }
  }, [pathname, lang, setLang]);

  return null;
}

/** Переключение языка с навигацией на пару hreflang-URL. */
export function navigateToLocale(
  navigate: ReturnType<typeof useNavigate>,
  pathname: string,
  nextLang: AppLang,
) {
  const { basePath } = parseLocalePath(pathname);
  const target = localizedPath(basePath, nextLang);
  try {
    localStorage.setItem(LANG_STORAGE_KEY, nextLang);
  } catch {
    /* ignore */
  }
  navigate(`${target}${window.location.search}${window.location.hash}`, { replace: true });
}
